"use strict";

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.configureItems();
      }).catch(e => {
        console.error(e);
      });
    };
    this.configureItems = this.configureItems.bind(this);
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px"
    }).observe(this);
  }
  configureItems() {
    const items = Array.from(this.querySelectorAll(".product-item"));
    const sliders = [];
    const initialStyles = [];
    items.forEach((item, idx) => {
      const el = item.querySelector(".product__images-container");
      sliders.push(null);
      initialStyles.push(el.getAttribute("style"));
      el.classList.add("slider-mode");
      sliders[idx] = new Swiper(el, {
        initialSlide: el.getAttribute("data-start-index") ? Number(el.getAttribute("data-start-index")) - 1 : 0,
        slidesPerView: 1,
        enabled: window.innerWidth > 768,
        navigation: {
          prevEl: el.querySelector(".slider-btn--prev"),
          nextEl: el.querySelector(".slider-btn--next")
        },
        loop: true
      });
      const toggleHover = state => {
        if (state && window.innerWidth > 768) {
          item.classList.add("--hovered");
        } else {
          item.classList.remove("--hovered");
        }
      };
      item.addEventListener("mouseenter", () => toggleHover(true));
      item.addEventListener("mouseleave", () => toggleHover(false));
      item.addEventListener("touchstart", () => toggleHover(true));
      item.addEventListener("touchend", () => toggleHover(false));
    });
    let mainSlider = [];
    const toggleMainSlider = destroy => {
      if (destroy) {
        if (mainSlider[0]) {
          mainSlider[0].destroy();
          mainSlider[0] = null;
        }
        sliders.forEach(slider => {
          slider.enable();
        });
        return;
      }
      sliders.forEach(slider => {
        slider.disable();
      });
      const el = this.querySelector(".product-recommendations__wrapper");
      mainSlider[0] = new Swiper(el, {
        speed: 400,
        slidesPerView: "auto",
        loop: true,
        initialSlide: 1,
        spaceBetween: 16,
        centeredSlides: true
      });
    };
    if (window.innerWidth <= 768) toggleMainSlider();
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768 && !mainSlider[0]) {
        toggleMainSlider();
      } else if (window.innerWidth > 768 && mainSlider[0]) {
        toggleMainSlider(true);
      }
    });
  }
}
customElements.define("product-recommendations", ProductRecommendations);